import { boxShadow, color } from '@upstox/upstox-ui';

export const modalContainer: CSSFunction = () => ({
  position: 'absolute',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
});

export const backdrop: CSSFunction = ({ theme }) => ({
  zIndex: 2,
  background: color(theme, theme.modals.backgroundBackdrop),
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
});

export const base: CSSFunction = ({ theme }) => ({
  zIndex: 3,
  backgroundColor: color(theme, theme.colors.background.default4),
  boxShadow: boxShadow(theme, theme.modals.boxShadow),
  margin: 'auto',
  width: 'min(360px, 90%)',
  height: 'max-content',
  overflow: 'hidden',
  padding: '0',
  position: 'absolute',
  borderRadius: '4px',
});

export const header: CSSFunction = () => ({
  width: '100%',
});

export const heading: CSSFunction = ({ theme }) => ({
  fontSize: '16px',
  color: color(theme, 'text.1'),
  textAlign: 'center',
  fontWeight: theme.fontWeights.bold,
  fontFamily: theme.fonts.tvFont,
});

export const description: CSSFunction = ({ theme, cssProps }) => ({
  textAlign: cssProps.textAlign as TextAligns || 'center',
  fontSize: '12px',
  lineHeight: '16px',
  fontFamily: theme.fonts.tvFont,
  color: theme.colors.text[2],
});

export const doneButton: CSSFunction = () => ({
  borderRadius: '4px',
});

export const list: CSSFunction = () => ({
  listStyleType: 'square',
});
